module.exports = __webpack_public_path__ + "img/desade.f7d0f2bc.png";